import API from 'api/index';
import { formatReceived } from 'utils/formatValues';
import { message } from 'antd';

const BASE_URI_PUBLIC = 'cuentaunicasir/ciudadano-caja-public/';

/**
 * Funcion para Armar el nombre copleto del ciudadano
 * @param {Object} ciudadano
 * @param {Boolean} showKey
 * @returns Object
 */
export const fullName = (ciudadano, showKey = true) => `${showKey
  && (Object.hasOwn(ciudadano, 'clave_ciudadana') || Object.hasOwn(ciudadano, 'clave'))
  ? `${ciudadano?.clave_ciudadana || ciudadano?.clave || ''} - `
  : ''}${ciudadano?.nombre
  || ''} ${ciudadano?.apellido_paterno
  || ''} ${ciudadano?.apellido_materno
  || ''}`;

/**
 *  Funcion para injectar el nombre completo del ciudadano con o sin clave
 * @param {Array} ciudadanos
 * @returns <Array|Object>
 */
const insertFullName = (ciudadanos) => {
  if (Array.isArray(ciudadanos)) {
    return ciudadanos.map((e) => ({
      ...e,
      nombre_completo: fullName(e),
      nombre_completo_corto: fullName(e, false),
    }));
  }
  return {
    ...ciudadanos,
    nombre_completo: fullName(ciudadanos),
    nombre_completo_corto: fullName(ciudadanos, false),
  };
};

/**
 * GET Ciudadano (por búsqueda avanzada)
 * @param {Object} params Parámetros de búsqueda (nombre, apellidos, etc.)
 * @returns {Promise<Object>}
 */
export const getCiudadanoPublic = async (params = {}) => {
  try {
    const response = await API.get(BASE_URI_PUBLIC, { params });
    return formatReceived(insertFullName(response.data));
  } catch (err) {
    message.error('Error al buscar ciudadano');
    return null;
  }
};
